<template>
	<div id="app" class="main-app" v-bind:class="[`view-${$route.name}`, {vuemodal:showModal}]">

		<transition name="fade" mode="out-in">
			<router-view ref="router" style="animation-duration: 0.3s"></router-view>
		</transition>

		<transition name="plopp" mode="out-in">	
			<ProductInfos v-if="productToShow" style="animation-duration: 0.3s" @close-clicked="closeProductInfos" :product="productToShow"></ProductInfos>
		</transition>

		<Intro v-if="showIntro" style="animation-duration: 0.3s" @close-clicked="closeIntro"></Intro>

		<transition name="plopp" mode="out-in">			
			<PdfViewer ref="pdfViewer" v-if="pdfToShow" style="animation-duration: 0.3s" :src="pdfToShow" @close-pdf-clicked="closePdfViewer"></PdfViewer>
		</transition>

		<transition name="fade">
			<div class="backdrop" v-move-to="`body`" v-if="showModal"></div>
		</transition>

	</div>	
</template>

<script>

import { BootService } from '@/services/boot.service'
import { EventBus } from '@/common/eventbus.js'
import { mapState } from 'vuex'
import { ApiService } from '@/services/api.service'
import { Navigation } from '@/services/navigation.service'

import { store } from './store'
import router from './router'

export default {
	name: 'app',
	router,
	store,
	data: function () {
		return {
			showIntro: false,
			showModal: false,
			productToShow: false,
			pdfToShow: false,
			openPdfExternally: false,
			timeout: false,
		}
	},
	computed: {
		...mapState('globals', ['app']),
		...mapState('settings', ['presets']),
	},
	watch: {
		$route(to, from) {
			this.resetTimer();
		}
	},
	mounted () {
		
		this.$nextTick( this.boot );

		// Bei Änderung der Viewport-Größe: Größen neu berechnen
		window.addEventListener( 'resize', () => {
			EventBus.$emit('recalc-viewport-size');
		});

		// Bei Änderung des ViewPorts: Größe global verfügbar machen
		EventBus.$on('recalc-viewport-size', this.recalcViewportSize );
		EventBus.$emit('recalc-viewport-size');

		// Click auf einen Menüpunkt
		EventBus.$on('nav-clicked', this.onNavClicked);

		// Click auf einen Hotspot
		EventBus.$on('hotspot-clicked', this.onClickHotspot);

		// Fenster mit Info schließen
		EventBus.$on('close-modals', () => {
			this.closeProductInfos();
			this.closePdfViewer();
		});
		
		// Click auf PDF zeigen
		EventBus.$on('show-pdf', this.onShowPdf);

		this.recalcViewportSize();
		//alert( ipcRenderer ); 
		//alert(process.env.EXE_PATH);
		//alert(process.env.APP_PATH);
	},

	beforeDestroy() {
		window.removeEventListener( 'resize', this.recalcViewportSize );
        EventBus.$off('recalc-viewport-size', this.recalcViewportSize);
	},

	methods: {

		/**
		 * 	App starten
		 */
		boot() {

			var hash = window.location.hash.split('#').pop();
			if (hash.indexOf('preloader') > -1) hash = '';

			// Splash-Screen zeigen
			this.$router.replace('/preloader').catch((err)=>{});

			// App booten, Settings laden, Root-Page laden...
			BootService.init().then( ({ data }) => {

				// App ist startklar.
				if (hash.length && hash != '/') {
					this.$router.push( hash ).catch((err) => {})
				} else {
					this.$router.push('/page/').catch((err) => {})
				}
				
				this.showModal = true;
				this.showIntro = true;
				this.resetTimer();
			});
		},

		recalcViewportSize() {
			var obj = {
				windowHeight: window.innerHeight,
				windowWidth: window.innerWidth,
				viewportWidth: this.$el.offsetWidth,
				viewportHeight: window.innerHeight,
				useMobileVersion: window.innerWidth < 765 && window.innerHeight * 0.8 > window.innerWidth,
			};
			this.$store.commit('globals/SET_APP_ATTRIBUTES', obj);
			EventBus.$emit('resizeWindow', obj);
		},

		/**
		 *  Nach bestimmter Zeit zurück zum Startscreen.
		 * 
		 */
		resetTimer() {
			clearTimeout( this.timeout );
			this.timeout = setTimeout(() => {
				EventBus.$emit('close-modals')
				this.$router.push('/page/').catch((err) => {})
			}, 300000 );
		},

		/**
		 * 	Click auf Hotspot:
		 * 	Layer mit Infos zum Produkt laden und zeigen
		 */
		onClickHotspot( ev ) {
			this.resetTimer();
			this.showIntro = false;
			this.showModal = true;
			ApiService.loadProductData( ev.link ).then(( {data} ) => {
				this.productToShow = data.entry;
			});
		},
		
		/**
		 * 	PDF zeigen
		 */
		onShowPdf( data ) {
			this.resetTimer();
			this.showModal = true;
			if (process.env.IS_ELECTRON) {
				if (this.$refs.pdfViewer) {
					this.$refs.pdfViewer.reset();
				}
				this.pdfToShow = ApiService.absoluteUrl(data.pdf);
				return;
			} else if (this.app.useMobileVersion || this.openPdfExternally) {
				window.open( ApiService.absoluteUrl( data.pdf ) );
				return false;
			}
			if (this.$refs.pdfViewer) {
				this.$refs.pdfViewer.reset();
			}
			this.pdfToShow = ApiService.absoluteUrl(data.pdf);
		},

		closeProductInfos() {
			this.productToShow = false;
			this.showModal = false;
		},

		closePdfViewer() {
			this.pdfToShow = false;
			this.showModal = false;
		},

		closeIntro() {
			this.showIntro = false;
			this.showModal = false;
		},

		onNavClicked( data ) {
			EventBus.$emit('close-modals');
			Navigation.go( data );
		}

	}

}
</script>

<style lang="scss">
	.backdrop {
		@include position(absolute, 0 0 0 0, 1400 );
		background: rgba(#000, 0.5);
	}
	.main-app {
		transition: 1s all;
		&.vuemodal {
			//filter: blur(2px);
			transform: scale(1.01);
		}
	}

</style>
